export default [
  {
    path: '/article',
    name: 'Article',
    component: () => import('@/views/Article/ArticleHome/ArticleHome.vue'),
    meta: { code: 'article' }
  },
  {
    path: '/article-list',
    name: 'ArticleList',
    component: () => import('@/views/Article/ArticleList/ArticleList.vue'),
    meta: { code: 'ArticleList' }
  },
  {
    path: '/column-list',
    name: 'ArticleColumnList',
    component: () => import('@/views/Article/ArticleColumnList/ArticleColumnList.vue'),
    meta: { code: 'article' }
  },
  {
    path: '/column',
    name: 'ArticleColumnContent',
    component: () => import('@/views/Article/ArticleColumnContent/ArticleColumnContent.vue'),
    meta: { code: 'article' }
  },
  {
    path: '/article-read',
    name: 'ArticleRead',
    component: () => import('@/views/Article/ArticleRead/ArticleRead.vue'),
    meta: { code: 'article' }
  },
]